import React, { useEffect } from 'react';
import styles from './FormPreview.module.scss';
import { useFetch } from 'hooks/useFetch';
import { workflow } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';
import GenerateForm from 'component/organism/chat-console/components/bot-response/factory/components/form/GenerateForms';
import { useUserContext } from 'app-context/user/UserContext';

const FormPreview = ({ formId, isNode, hasPreview = true, disabled }) => {
  const { selectedBot } = useUserContext();
  const {
    data: formPreview,
    refetch,
    isPending: isShowingForm,
  } = useFetch(['getFormsById', formId], workflow.getFormById(formId), {
    enabled: !!formId,
  });

  useEffect(() => {
    if (formId) {
      refetch();
    }
  }, [formId]);

  if (isShowingForm && formId) {
    return (
      <div className={styles.cont}>
        <Loader isComponent />
      </div>
    );
  }

  return formPreview?.data ? (
    <div className={styles.cont}>
      <div>
        {hasPreview ? <p className={styles.title}>Preview</p> : null}
        <p className={styles.subTitle}>{formPreview?.data?.formTitle}</p>
      </div>
      <div className={styles['preview-container']}>
        {/* <div className={styles['bot']}>
          <div className={styles['bot-default']}>
            <p>
              {selectedBot?.botName
                ?.split(' ')
                .map((word) => word.charAt(0))
                .join('')}
            </p>
          </div>
        </div> */}
        <GenerateForm
          step={{
            value: { formDetails: formPreview?.data?.formDetails },
            buttonText: formPreview?.data?.buttonText,
          }}
          classname={styles.form}
          isNode={isNode}
          disabled={disabled}
        />
      </div>
    </div>
  ) : null;
};

export default FormPreview;
